class BackInStockConfiguration {
    constructor() {
        this.get = () => {
            if (!this.config) {
                throw Error('back in stock notification config has not been provided');
            }
            return this.config;
        };
        this.getConfig = () => {
            if (!this.config) {
                throw Error('back in stock notification config has not been provided');
            }
            return this.config.config;
        };
    }
    init(config) {
        this.config = config;
    }
}
const backInStockConfiguration = new BackInStockConfiguration();
export { backInStockConfiguration as BackInStockConfiguration };
